import { ConnectOTVB } from 'entities/application/constants/applications/OTVB/ConnectOTVB/ConnectOTVB';
import { ApplicationWithDetails } from '../../../types';
import { OTVBInstructions } from './OTVBInstructions/OTVBInstructions';

export const OTVB: ApplicationWithDetails = {
	id: `11ECF3AAF97D059CB9706F21406EAB73`,
	name: `Экран с отзывами клиентов`,
	description: `Метрики и отзывы клиентов в\xa0реальном времени.`,
	descriptionLong: `Отзывы клиентов и метрики теперь всегда под рукой\n\nНаблюдайте за отзывами клиентов и метриками ресторана и доставки в реальном времени. Приложение показывает клиентский рейтинг и скорость приготовления заказа в ресторане, клиентский рейтинг и среднее время доставки. Никакой модерации, все отзывы публикуются с сохранением “орфографии и пунктуации” авторов. Приложение можно вывести на экран монитора или большой телевизор в офисе или на рецепшне. \n\nИзмеряем → Наблюдаем → Улучшаем!`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/otvb/logo-n`,
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/otvb/bgr`,
	sliders: [
		`https://cdn.dodostatic.net/static/marketplace/otvb/slider1-new`,
		`https://cdn.dodostatic.net/static/marketplace/otvb/slider2-new`,
		`https://cdn.dodostatic.net/static/marketplace/otvb/slider3-new`,
		`https://cdn.dodostatic.net/static/marketplace/otvb/slider4-new`,
	],
	// eslint-disable-next-line sonarjs/no-duplicate-string
	webSiteUrl: ``,
	supportUrl: `https://office-tv-board.dodois.io/`,
	redirectUrl: ``,
	contactEmail: `support@dodopizza.com`,
	supportEmail: ``,
	categories: [`Обратная связь`, `Общение`, `Клиенты`, `Офис`],
	countries: [`Все`],
	languages: [`Руccкий`, `English`],
	conceptions: [`Dodo Pizza`],
	price: `Бесплатно`,
	type: `ТВ-Борд`,
	version: `1.0`,
	developer: `Dodo Brands`,
	plans: null,
	instructions: OTVBInstructions,
	details: null,
	knowledgeBase: null,
	isExternal: false,
	showInstruction: false,
	versionHistory: null,
	status: `updated`,
	goToApp: true,
	hasAdditionalFlow: ConnectOTVB,
};
